import PropTypes from 'prop-types';
import React from 'react';

import Button from '../../components/Button/Button';
import Content from '../../components/Content/Content';

const ErrorSendAppeal = ({ onHideRequestError }) => (
  <Content>
    <Content.Title>Заявление не удалось отправить</Content.Title>
    <Content.Text>В процессе подачи заявления произошла ошибка!</Content.Text>
    <Content.Button>
      <Button
        primary
        onClick={() => {
          onHideRequestError(true);
          window.scrollTo(0, 0);
        }}
      >
        Вернуться к списку предметов
      </Button>
    </Content.Button>
    <Content.Link>
      <a
        className="Link"
        href="https://mos.ru/otvet-obrazovanie/kak-zapisat-rebenka-v-shkolu/"
      >
        Как перевести ребенка в другую школу
      </a>
    </Content.Link>
    <Content.Link>
      <a
        className="Link"
        href="https://mos.ru/otvet-obrazovanie/kak-uznat-raspisanie-ege-oge-i-gve/"
      >
        Как узнать расписание ЕГЭ, ОГЭ и ГВЭ
      </a>
    </Content.Link>
    <Content.Link>
      <a
        className="Link"
        href="https://mos.ru/otvet-obrazovanie/kak-perevesti-bally-za-ege-i-oge-v-pyatiballnuyu-shkalu/"
      >
        Как перевести баллы за ЕГЭ и ОГЭ в пятибалльную шкалу
      </a>
    </Content.Link>
    <Content.Link>
      <a
        className="Link"
        href="https://mos.ru/search?category=instruction&hostApplied=false&page=1&q="
      >
        Все инструкции
      </a>
    </Content.Link>
  </Content>
);

ErrorSendAppeal.propTypes = {
  onHideRequestError: PropTypes.func.isRequired
};

export default ErrorSendAppeal;
